import React from "react";
import { useState, useEffect } from "react";
import '../css/nav.css'
import src from '../assets/logo.png'
import { FaAngleDown, FaBars } from 'react-icons/fa';
import { Link, NavLink, useLocation } from "react-router-dom";
import { HashLink } from 'react-router-hash-link'


const Nav = () => {
    const [vis, setvis] = useState(true)
    const [add, setadd] = useState(false)

    const sideclick = () => {
        if (vis) {
            document.getElementById('menu').style.display = 'none'
            // document.getElementById('menu').style.height='0px'
            // document.getElementById('menu').classList.toggle("classname")   // It could also be used to get the same function
            setvis(false)
        } else {
            document.getElementById('menu').style.display = 'block'
            // document.getElementById('menu').style.height='max-content'
            setvis(true)
        }
    }


    const { pathname } = useLocation();
    useEffect(() => {

        if(window.outerWidth<990){
        document.getElementById('menu').style.display = 'none'

        }
    }, [pathname]);



    return (
        <header className="header" >
            <div className="headerin" >
                <div className="imagecontainer" >
                    <Link className="anchorimg" to="/" style={{textDecoration:'none', color:'rgb(141 138 138)', fontSize:'23px', fontFamily:'Raleway'}}>
                        {/* <img src={src} alt="NO Image" className="image"
                        /> */}
                        <h3 style={{margin:'0px', padding:'0px', lineHeight:'65px'}}>AL-REHMAN</h3>
                    </Link>
                </div>
                <div id="threelinesbtn" className="sidethreelines" onClick={sideclick}><FaBars /></div>
                <div id="menu" className="menu" >
                    <ul role="menubar" className="navul"  >
                        <li role='menuitem' className="linav ">
                            <NavLink to="/" className="anli" ><span className="navspan" >HOME</span></NavLink>
                        </li>
                        <li id="aboutdivof" role='menuitem' className="linav "  >
                            <NavLink to="/about" className="anli" ><span className="navspan" >ABOUT US</span></NavLink>
                            {/* <span className="aboutside" id="aboutsidebtn" onClick={aboutsidebtnclick}><FaAngleDown /></span> */}
                           
                        </li>
                        <li id="serdivof" role='menuitem' className="linav " >
                            <NavLink to="/services" className="anli" ><span className="navspan" >OUR SERVICES</span></NavLink>
                            {/* <span className="aboutside" id="seraboutbtn" onClick={sersidebtnclick}><FaAngleDown /></span> */}
                        </li>
                        <li role='menuitem' className="linav " >
                            <NavLink to="/contact" className="anli" ><span className="navspan" >CONTACT US</span></NavLink>
                        </li>
                        
                        <li className="navbtn" >
                            <span className="btnspan" >+92-341-752-2886</span>
                        </li>
                    </ul>
                </div>
            </div>

        </header>
    )
}
export default Nav